import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "name", "required"]
const _hoisted_2 = {
  key: 0,
  value: "",
  disabled: "",
  selected: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("select", {
    id: _ctx.id,
    name: _ctx.name,
    class: _normalizeClass(_ctx.classes),
    required: _ctx.required,
    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
  }, [
    (_ctx.placeholder)
      ? (_openBlock(), _createElementBlock("option", _hoisted_2, _toDisplayString(_ctx.placeholder), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 42, _hoisted_1))
}